/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable import/no-anonymous-default-export */
export default [
    [//cd91
      {
          date: "2021/03/02",
      price: 0.74,
      },
      {
          date: "2021/03/03",
      price: 0.74,
      },
      {
          date: "2021/03/04",
      price: 0.74,
      },
      {
          date: "2021/03/05",
      price: 0.74,
      },
      {
          date: "2021/03/08",
      price: 0.74,
      },
      {
          date: "2021/03/09",
      price: 0.75,
      },
      {
          date: "2021/03/10",
      price: 0.75,
      },
      {
          date: "2021/03/11",
      price: 0.75,
      },
      {
          date: "2021/03/12",
      price: 0.75,
      },
      {
          date: "2021/03/15",
      price: 0.75,
      },
      {
          date: "2021/03/16",
      price: 0.75,
      },
      {
          date: "2021/03/17",
      price: 0.75,
      },
      {
          date: "2021/03/18",
      price: 0.75,
      },
      {
          date: "2021/03/19",
      price: 0.75,
      },
      {
          date: "2021/03/22",
      price: 0.75,
      },
      {
          date: "2021/03/23",
      price: 0.75,
      },
      {
          date: "2021/03/24",
      price: 0.75,
      },
      {
          date: "2021/03/25",
      price: 0.75,
      },
      {
          date: "2021/03/26",
      price: 0.75,
      },
      {
          date: "2021/03/29",
      price: 0.75,
      },
      {
          date: "2021/03/30",
      price: 0.75,
      },
      {
          date: "2021/03/31",
      price: 0.75,
      },
      {
          date: "2021/04/01",
      price: 0.75,
      },
      {
          date: "2021/04/02",
      price: 0.75,
      },
      {
          date: "2021/04/05",
      price: 0.75,
      },
      {
          date: "2021/04/06",
      price: 0.75,
      },
      {
          date: "2021/04/07",
      price: 0.75,
      },
      {
          date: "2021/04/08",
      price: 0.75,
      },
      {
          date: "2021/04/09",
      price: 0.75,
      },
      {
          date: "2021/04/12",
      price: 0.75,
      },
      {
          date: "2021/04/13",
      price: 0.73,
      },
      {
          date: "2021/04/14",
      price: 0.73,
      },
      {
          date: "2021/04/15",
      price: 0.73,
      },
      {
          date: "2021/04/16",
      price: 0.73,
      },
      {
          date: "2021/04/19",
      price: 0.73,
      },
      {
          date: "2021/04/20",
      price: 0.73,
      },
      {
          date: "2021/04/21",
      price: 0.73,
      },
      {
          date: "2021/04/22",
      price: 0.73,
      },
      {
          date: "2021/04/23",
      price: 0.73,
      },
      {
          date: "2021/04/26",
      price: 0.73,
      },
      {
          date: "2021/04/27",
      price: 0.73,
      },
      {
          date: "2021/04/28",
      price: 0.73,
      },
      {
          date: "2021/04/29",
      price: 0.73,
      },
      {
          date: "2021/04/30",
      price: 0.73,
      },
      {
          date: "2021/05/03",
      price: 0.73,
      },
      {
          date: "2021/05/04",
      price: 0.73,
      },
      {
          date: "2021/05/06",
      price: 0.73,
      },
      {
          date: "2021/05/07",
      price: 0.72,
      },
      {
          date: "2021/05/10",
      price: 0.71,
      },
      {
          date: "2021/05/11",
      price: 0.69,
      },
      {
          date: "2021/05/12",
      price: 0.69,
      },
      {
          date: "2021/05/13",
      price: 0.67,
      },
      {
          date: "2021/05/14",
      price: 0.67,
      },
      {
          date: "2021/05/17",
      price: 0.67,
      },
      {
          date: "2021/05/18",
      price: 0.67,
      },
      {
          date: "2021/05/20",
      price: 0.66,
      },
      {
          date: "2021/05/21",
      price: 0.66,
      },
      {
          date: "2021/05/24",
      price: 0.66,
      },
      {
          date: "2021/05/25",
      price: 0.66,
      },
      {
          date: "2021/05/26",
      price: 0.66,
      },
      {
          date: "2021/05/27",
      price: 0.66,
      },
      {
          date: "2021/05/28",
      price: 0.66,
      },
      {
          date: "2021/05/31",
      price: 0.66,
      },
      {
          date: "2021/06/01",
      price: 0.66,
      },
      {
          date: "2021/06/02",
      price: 0.66,
      },
      {
          date: "2021/06/03",
      price: 0.66,
      },
      {
          date: "2021/06/04",
      price: 0.66,
      },
      {
          date: "2021/06/07",
      price: 0.66,
      },
      {
          date: "2021/06/08",
      price: 0.66,
      },
      {
          date: "2021/06/09",
      price: 0.66,
      },
      {
          date: "2021/06/10",
      price: 0.66,
      },
      {
          date: "2021/06/11",
      price: 0.66
      },
    ],
    [//korea3
      {
          date: "2021/03/02",
      price: 1.021,
      },
      {
          date: "2021/03/03",
      price: 1.019,
      },
      {
          date: "2021/03/04",
      price: 1.03,
      },
      {
          date: "2021/03/05",
      price: 1.066,
      },
      {
          date: "2021/03/08",
      price: 1.139,
      },
      {
          date: "2021/03/09",
      price: 1.206,
      },
      {
          date: "2021/03/10",
      price: 1.182,
      },
      {
          date: "2021/03/11",
      price: 1.179,
      },
      {
          date: "2021/03/12",
      price: 1.223,
      },
      {
          date: "2021/03/15",
      price: 1.238,
      },
      {
          date: "2021/03/16",
      price: 1.177,
      },
      {
          date: "2021/03/17",
      price: 1.177,
      },
      {
          date: "2021/03/18",
      price: 1.133,
      },
      {
          date: "2021/03/19",
      price: 1.146,
      },
      {
          date: "2021/03/22",
      price: 1.13,
      },
      {
          date: "2021/03/23",
      price: 1.132,
      },
      {
          date: "2021/03/24",
      price: 1.115,
      },
      {
          date: "2021/03/25",
      price: 1.089,
      },
      {
          date: "2021/03/26",
      price: 1.117,
      },
      {
          date: "2021/03/29",
      price: 1.119,
      },
      {
          date: "2021/03/30",
      price: 1.155,
      },
      {
          date: "2021/03/31",
      price: 1.133,
      },
      {
          date: "2021/04/01",
      price: 1.138,
      },
      {
          date: "2021/04/02",
      price: 1.151,
      },
      {
          date: "2021/04/05",
      price: 1.202,
      },
      {
          date: "2021/04/06",
      price: 1.181,
      },
      {
          date: "2021/04/07",
      price: 1.181,
      },
      {
          date: "2021/04/08",
      price: 1.152,
      },
      {
          date: "2021/04/09",
      price: 1.168,
      },
      {
          date: "2021/04/12",
      price: 1.14,
      },
      {
          date: "2021/04/13",
      price: 1.138,
      },
      {
          date: "2021/04/14",
      price: 1.102,
      },
      {
          date: "2021/04/15",
      price: 1.147,
      },
      {
          date: "2021/04/16",
      price: 1.154,
      },
      {
          date: "2021/04/19",
      price: 1.129,
      },
      {
          date: "2021/04/20",
      price: 1.134,
      },
      {
          date: "2021/04/21",
      price: 1.11,
      },
      {
          date: "2021/04/22",
      price: 1.105,
      },
      {
          date: "2021/04/23",
      price: 1.12,
      },
      {
          date: "2021/04/26",
      price: 1.119,
      },
      {
          date: "2021/04/27",
      price: 1.097,
      },
      {
          date: "2021/04/28",
      price: 1.105,
      },
      {
          date: "2021/04/29",
      price: 1.121,
      },
      {
          date: "2021/04/30",
      price: 1.141,
      },
      {
          date: "2021/05/03",
      price: 1.149,
      },
      {
          date: "2021/05/04",
      price: 1.158,
      },
      {
          date: "2021/05/06",
      price: 1.14,
      },
      {
          date: "2021/05/07",
      price: 1.137,
      },
      {
          date: "2021/05/10",
      price: 1.136,
      },
      {
          date: "2021/05/11",
      price: 1.128,
      },
      {
          date: "2021/05/12",
      price: 1.121,
      },
      {
          date: "2021/05/13",
      price: 1.123,
      },
      {
          date: "2021/05/14",
      price: 1.116,
      },
      {
          date: "2021/05/17",
      price: 1.107,
      },
      {
          date: "2021/05/18",
      price: 1.099,
      },
      {
          date: "2021/05/20",
      price: 1.103,
      },
      {
          date: "2021/05/21",
      price: 1.095,
      },
      {
          date: "2021/05/24",
      price: 1.116,
      },
      {
          date: "2021/05/25",
      price: 1.142,
      },
      {
          date: "2021/05/26",
      price: 1.161,
      },
      {
          date: "2021/05/27",
      price: 1.124,
      },
      {
          date: "2021/05/28",
      price: 1.162,
      },
      {
          date: "2021/05/31",
      price: 1.227,
      },
      {
          date: "2021/06/01",
      price: 1.213,
      },
      {
          date: "2021/06/02",
      price: 1.206,
      },
      {
          date: "2021/06/03",
      price: 1.191,
      },
      {
          date: "2021/06/04",
      price: 1.22,
      },
      {
          date: "2021/06/07",
      price: 1.201,
      },
      {
          date: "2021/06/08",
      price: 1.174,
      },
      {
          date: "2021/06/09",
      price: 1.137,
      },
      {
          date: "2021/06/10",
      price: 1.282,
      },
      {
          date: "2021/06/11",
      price: 1.276
      },
    ],
    [//cb3
      {
          date: "2021/03/02",
      price: 8.433,
      },
      {
          date: "2021/03/03",
      price: 8.43,
      },
      {
          date: "2021/03/04",
      price: 8.437,
      },
      {
          date: "2021/03/05",
      price: 8.461,
      },
      {
          date: "2021/03/08",
      price: 8.494,
      },
      {
          date: "2021/03/09",
      price: 8.547,
      },
      {
          date: "2021/03/10",
      price: 8.507,
      },
      {
          date: "2021/03/11",
      price: 8.495,
      },
      {
          date: "2021/03/12",
      price: 8.523,
      },
      {
          date: "2021/03/15",
      price: 8.53,
      },
      {
          date: "2021/03/16",
      price: 8.491,
      },
      {
          date: "2021/03/17",
      price: 8.494,
      },
      {
          date: "2021/03/18",
      price: 8.443,
      },
      {
          date: "2021/03/19",
      price: 8.45,
      },
      {
          date: "2021/03/22",
      price: 8.434,
      },
      {
          date: "2021/03/23",
      price: 8.431,
      },
      {
          date: "2021/03/24",
      price: 8.417,
      },
      {
          date: "2021/03/25",
      price: 8.402,
      },
      {
          date: "2021/03/26",
      price: 8.417,
      },
      {
          date: "2021/03/29",
      price: 8.417,
      },
      {
          date: "2021/03/30",
      price: 8.436,
      },
      {
          date: "2021/03/31",
      price: 8.418,
      },
      {
          date: "2021/04/01",
      price: 8.421,
      },
      {
          date: "2021/04/02",
      price: 8.425,
      },
      {
          date: "2021/04/05",
      price: 8.453,
      },
      {
          date: "2021/04/06",
      price: 8.438,
      },
      {
          date: "2021/04/07",
      price: 8.433,
      },
      {
          date: "2021/04/08",
      price: 8.413,
      },
      {
          date: "2021/04/09",
      price: 8.419,
      },
      {
          date: "2021/04/12",
      price: 8.394,
      },
      {
          date: "2021/04/13",
      price: 8.39,
      },
      {
          date: "2021/04/14",
      price: 8.363,
      },
      {
          date: "2021/04/15",
      price: 8.389,
      },
      {
          date: "2021/04/16",
      price: 8.391,
      },
      {
          date: "2021/04/19",
      price: 8.298,
      },
      {
          date: "2021/04/20",
      price: 8.302,
      },
      {
          date: "2021/04/21",
      price: 8.277,
      },
      {
          date: "2021/04/22",
      price: 8.274,
      },
      {
          date: "2021/04/23",
      price: 8.285,
      },
      {
          date: "2021/04/26",
      price: 8.281,
      },
      {
          date: "2021/04/27",
      price: 8.262,
      },
      {
          date: "2021/04/28",
      price: 8.263,
      },
      {
          date: "2021/04/29",
      price: 8.272,
      },
      {
          date: "2021/04/30",
      price: 8.28,
      },
      {
          date: "2021/05/03",
      price: 8.284,
      },
      {
          date: "2021/05/04",
      price: 8.287,
      },
      {
          date: "2021/05/06",
      price: 8.266,
      },
      {
          date: "2021/05/07",
      price: 8.266,
      },
      {
          date: "2021/05/10",
      price: 8.264,
      },
      {
          date: "2021/05/11",
      price: 8.257,
      },
      {
          date: "2021/05/12",
      price: 8.253,
      },
      {
          date: "2021/05/13",
      price: 8.254,
      },
      {
          date: "2021/05/14",
      price: 8.249,
      },
      {
          date: "2021/05/17",
      price: 8.239,
      },
      {
          date: "2021/05/18",
      price: 8.232,
      },
      {
          date: "2021/05/20",
      price: 8.237,
      },
      {
          date: "2021/05/21",
      price: 8.229,
      },
      {
          date: "2021/05/24",
      price: 8.244,
      },
      {
          date: "2021/05/25",
      price: 8.259,
      },
      {
          date: "2021/05/26",
      price: 8.271,
      },
      {
          date: "2021/05/27",
      price: 8.237,
      },
      {
          date: "2021/05/28",
      price: 8.271,
      },
      {
          date: "2021/05/31",
      price: 8.318,
      },
      {
          date: "2021/06/01",
      price: 8.303,
      },
      {
          date: "2021/06/02",
      price: 8.298,
      },
      {
          date: "2021/06/03",
      price: 8.282,
      },
      {
          date: "2021/06/04",
      price: 8.301,
      },
      {
          date: "2021/06/07",
      price: 8.283,
      },
      {
          date: "2021/06/08",
      price: 8.263,
      },
      {
          date: "2021/06/09",
      price: 8.237,
      },
      {
          date: "2021/06/10",
      price: 8.25,
      },
],
]